<template>
    <b-alert :variant="view.variant" show class="readiness-banner mb-0">
        <div class="d-flex align-items-start">
            <i :class="['bi', view.icon, 'mr-2', 'readiness-icon']"></i>
            <div class="flex-grow-1">
                <div class="fw-500">{{ view.title }}</div>
                <div v-if="view.detail" class="small mt-1">{{ view.detail }}</div>
            </div>
            <b-button
                v-if="view.ctaLabel"
                size="sm"
                :variant="`outline-${view.variant}`"
                class="ml-2 flex-shrink-0"
                @click="$emit('cta', { action: view.ctaAction, missingKeys: view.missingKeys })"
            >
                {{ view.ctaLabel }}
            </b-button>
        </div>
    </b-alert>
</template>

<script>
import {readinessView} from './readiness-labels';

export default {
    name: 'ReadinessBanner',
    props: {
        // campaign-readiness API 응답. null 이면 로딩 상태로 표시.
        readiness: {type: Object, default: null},
    },
    computed: {
        view() {
            return readinessView(this.readiness);
        },
    },
};
</script>

<style lang="scss" scoped>
.readiness-banner {
    border-radius: 8px;
}

.readiness-icon {
    font-size: 1.25rem;
    line-height: 1.4;
}
</style>
